/**
 * @typedef {'morning' | 'afternoon' | 'evening' | 'night'} GreetingTimeBlock
 * @typedef {'calm' | 'energised' | 'reflective' | 'supportive' | 'rest'} GreetingMood
 *
 * @typedef {Object} GreetingSession
 * @property {string} [id]
 * @property {string} [studentName]
 * @property {Date|string|number} [startTime]
 * @property {Date|string|number} [scheduledTime]
 * @property {boolean} [flagged]
 * @property {string} [status]
 *
 * @typedef {Object} GreetingContext
 * @property {Date} currentTime
 * @property {string} userName
 * @property {boolean} calendarAvailable
 * @property {number} sessionsBeforeLunch
 * @property {number} remainingSessions
 * @property {number} completedSessions
 * @property {number} pendingNotes
 * @property {number} continuousSessionStreak
 * @property {GreetingSession|null} nextSession
 * @property {boolean} hasFlaggedUpcoming
 * @property {GreetingSession[]} todaysSessions
 *
 * @typedef {Object} GreetingResult
 * @property {string} title
 * @property {string} message
 * @property {string} chipText
 * @property {string} [chipSecondary]
 * @property {string} gradient
 * @property {string} icon
 * @property {GreetingMood} mood
 * @property {GreetingTimeBlock} timeBlock
 * @property {boolean} showBreakReminder
 */

export const TIME_BLOCKS = {
	MORNING: 'morning',
	AFTERNOON: 'afternoon',
	EVENING: 'evening',
	NIGHT: 'night',
}

export const GREETING_MOODS = {
	CALM: 'calm',
	ENERGISED: 'energised',
	REFLECTIVE: 'reflective',
	SUPPORTIVE: 'supportive',
	REST: 'rest',
}
